import React, { useEffect, useState } from "react";
import {
  DialogContent,
  CardContent,
  Card,
  TableContainer,Table,TableRow,TableBody
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import TableBodyCell from "components/table/TableBodyCell";
import {autoDisbursementSettlement} from '../../../../shared/api/purple/autoDisbursement'
import { BootstrapBadge } from "components/ui/BootstrapBadge";

export const SettlementDetailsModel = (props) => {
  const { visible, callbackEvent} = props;
  const [settlementModalData ,setSettlementModalData]= useState([])

  const SettlementData = {
    "settlement_id":[props.data]
  }
  const fetchSettlementData = async () =>{
    autoDisbursementSettlement(SettlementData)
    .then((res) =>{
      if(res.message === "Success")
      {
        setSettlementModalData(res.data.all_transaction)
      }
    })
  }
  

  useEffect(() =>{
    fetchSettlementData()
    // eslint-disable-next-line
  },[])

  return (
    <Spin>
      <KisshtDialog
        title={"Merchant Settlement"}
        maxWidth={"md"}
        open={visible}
        handleClose={callbackEvent}
      >
        <DialogContent>
          <Card>
            <CardContent>
              <TableContainer>
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%",border:"solid 0.6px gray"}}>
              {settlementModalData?.map((item) =>{
                 return <TableBody>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Order Id</TableBodyCell>
                  <TableBodyCell>{item.merchant_order_id || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Transaction Closing Date	</TableBodyCell>
                  <TableBodyCell>{item.transaction_closing_date || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Site Name</TableBodyCell>
                  <TableBodyCell>{item.label || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Product Value</TableBodyCell>
                  <TableBodyCell>{item.product_value || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Loan Reference Number	</TableBodyCell>
                  <TableBodyCell>{item.loan_reference_number || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Loan Amount</TableBodyCell>
                  <TableBodyCell>{item.loan_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Warranty Amount	</TableBodyCell>
                  <TableBodyCell>{item.warranty_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Total Addon Value</TableBodyCell>
                  <TableBodyCell>{item.total_addon_value || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >MDR Rate	</TableBodyCell>
                  <TableBodyCell>{item.mdr_rate || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >MDR Amount	</TableBodyCell>
                  <TableBodyCell>{item.mdr_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Service Tax Rate	</TableBodyCell>
                  <TableBodyCell>{item.service_tax_rate || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Service Tax Amount	</TableBodyCell>
                  <TableBodyCell>{item.service_tax_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Paid In Store	</TableBodyCell>
                  <TableBodyCell>{item.paid_in_store || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Adjustment Amount</TableBodyCell>
                  <TableBodyCell>{item.adjustment_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Adjustment Description	</TableBodyCell>
                  <TableBodyCell>{item.adjustment_desc || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Settlement Amount</TableBodyCell>
                  <TableBodyCell>{item.settlement_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Subvention Rate	</TableBodyCell>
                  <TableBodyCell>{item.merchant_subvention_rate || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Subvention Amount	</TableBodyCell>
                  <TableBodyCell>{item.merchant_subvention_amount || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Account</TableBodyCell>
                  <TableBodyCell>{item.account_entry_type || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Settlement Date	</TableBodyCell>
                  <TableBodyCell>{item.settlement_date || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Is Settled </TableBodyCell>
                  <TableBodyCell> 
                  <BootstrapBadge
                                    color="#fff"
                                    text={item.is_settled || "-"}
                                ></BootstrapBadge>
                  {/* <Button
                      variant="contained"
                      className="shadow-none"
                      color="primary"
                      size="sm">Disburse</Button> */}
                  </TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Transaction Type	</TableBodyCell>
                  <TableBodyCell>{item.transaction_type || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >UTR No	</TableBodyCell>
                  <TableBodyCell>{item.bank_utr_no || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Paid Via Bank	</TableBodyCell>
                  <TableBodyCell>{item.paid_via_bank || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Customer Name</TableBodyCell>
                  <TableBodyCell>{item.user_fname || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Customer Mobile	</TableBodyCell>
                  <TableBodyCell>{item.user_mobile || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Customer Email	</TableBodyCell>
                  <TableBodyCell>{item.user_email || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Bank Name	</TableBodyCell>
                  <TableBodyCell>{item.bank_name}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Bank Ifsc Code	</TableBodyCell>
                  <TableBodyCell>{item.bank_ifsc_code || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Bank Account Number	</TableBodyCell>
                  <TableBodyCell>{item.bank_account_no || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Account Holder Name	</TableBodyCell>
                  <TableBodyCell>{item.bank_account_holder_name || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Merchant Reference</TableBodyCell>
                  <TableBodyCell>{item.merchant_reference_number || "-"}</TableBodyCell>
                </TableRow>
                <TableRow>
                  <TableBodyCell className="font-semibold" >Financier Company Name	</TableBodyCell>
                  <TableBodyCell>{item.financier_company_name || "-"}</TableBodyCell>
                </TableRow>
               </TableBody>

               })} 
                 
                </Table>
              </TableContainer> 
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};

export default SettlementDetailsModel;
